import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: fit-content;

  &[data-disabled='true'] {
    opacity: 0.6;
    pointer-events: none;
  }
`;

export const Label = styled.label`
  font-size: 0.8571428571428571em;
  font-style: inherit;
  color: #6b778c;
  font-weight: 600;
  line-height: 1.3333333333333333;
  display: inline-block;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  margin-bottom: 4px;
`;

export const Group = styled.div`
  display: inline-flex;
  border: 1px solid #bdbdbd;
  border-radius: 3.5px;
  overflow: hidden;
  background: #f7f7f7;

  --seg-item-width: auto;

  &[data-limit-reached='true'] {
    box-shadow: 0 0 0 2px rgba(124, 0, 255, 0.15) inset;
  }
`;

export const ItemButton = styled.button`
  appearance: none;
  border: 0;
  outline: none;
  background: #e0e0e0;
  padding: 8px 14px;
  font-size: 0.92rem;
  color: #333;
  cursor: pointer;
  transition: background 120ms ease, color 120ms ease, transform 40ms ease;
  white-space: nowrap;
  width: var(--seg-item-width);

  &:not(:last-child) {
    border-right: 1px solid #bdbdbd;
  }

  &[data-selected='true'] {
    background: #8850bf;
    color: #fff;
  }

  &:hover {
    filter: brightness(0.98);
  }

  &:active {
    transform: translateY(1px);
  }

  &:focus-visible {
    box-shadow: inset 0 0 0 2px rgba(0, 0, 0, 0.25);
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
`;

export const Hint = styled.div`
  font-size: 0.8rem;
  color: #666;
`;
